<div class="banner-and-form-container">
  <sms-info-banner></sms-info-banner>
  <sms-registration-error-banner></sms-registration-error-banner>
  <glxy-alert type="warning" [extendedBorder]="true">
    <div class="alert-header">
      <h2>
        <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.TITLE' | translate }}</strong>
      </h2>
      <button mat-icon-button (click)="showDetails.set(!showDetails())">
        <mat-icon>{{ showDetails() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
    @if (showDetails()) {
      <glxy-alert-extended>
        <div>
          <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.BOLD_BODY' | translate }}</strong>
          {{ 'INBOX.SETTINGS.A2P_REGISTRATION.BODY' | translate }}
        </div>
        <h3>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.HEADER' | translate }}</h3>
        <p>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.BODY' | translate }}</p>
        <ul>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIRST_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIRST_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.SECOND_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.SECOND_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.THIRD_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.THIRD_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FOURTH_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FOURTH_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIFTH_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_ONE.FIFTH_TEXT' | translate }}
          </li>
        </ul>
        <h3>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.HEADER' | translate }}</h3>
        <p>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.BODY' | translate }}</p>
        <ul>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.FIRST_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.FIRST_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.SECOND_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.SECOND_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.THIRD_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_TWO.THIRD_TEXT' | translate }}
          </li>
        </ul>
        <h3>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.HEADER' | translate }}</h3>
        <p>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.BODY' | translate }}</p>
        <ul>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.FIRST_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.FIRST_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.SECOND_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.SECOND_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.THIRD_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_THREE.THIRD_TEXT' | translate }}
          </li>
        </ul>
        <h3>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_FOUR.HEADER' | translate }}</h3>
        <p>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_FOUR.BODY' | translate }}</p>
        <ul>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_FOUR.FIRST_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_FOUR.FIRST_TEXT' | translate }}
          </li>
          <li>
            <strong>{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_FOUR.SECOND_BOLDED' | translate }}</strong
            >{{ 'INBOX.SETTINGS.A2P_REGISTRATION.STEP_FOUR.SECOND_TEXT' | translate }}
          </li>
        </ul>
      </glxy-alert-extended>
    }
  </glxy-alert>
  <sms-registration-form></sms-registration-form>
</div>

@if (canSubmit()) {
  <glxy-sticky-footer>
    @if (isA2pSubmitRestricted()) {
      <button mat-flat-button color="primary" (click)="saveChanges()">
        {{ 'SMS_REGISTRATION.FORM.ACTIONS.SAVE_CHANGES' | translate }}
      </button>
    } @else {
      <button mat-stroked-button (click)="saveChanges()">
        {{ 'SMS_REGISTRATION.FORM.ACTIONS.SAVE_CHANGES' | translate }}
      </button>
    }
    <button mat-flat-button color="primary" (click)="submitRegistration()" [disabled]="isA2pSubmitRestricted()">
      {{
        (isCampaignError()
          ? 'SMS_REGISTRATION.FORM.ACTIONS.RESUBMIT_REGISTRATION'
          : 'SMS_REGISTRATION.FORM.ACTIONS.SUBMIT_INFORMATION'
        ) | translate
      }}
    </button>
    @if (isA2pSubmitRestricted()) {
      <glxy-alert type="warning" size="small" [border]="false">
        {{ 'SMS_REGISTRATION.FORM.TRIAL_RESTRICTION_MESSAGE' | translate }}
      </glxy-alert>
    }
  </glxy-sticky-footer>
}
